/** @jsxImportSource @emotion/react */
import { useState, useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { Card } from "primereact/card";
import { Column } from "primereact/column";
import { Accordion, AccordionTab } from "primereact/accordion";
import { Toast } from "primereact/toast";
import { Skeleton } from "primereact/skeleton";
import { accessAPI, tituloBase, Titulo, TablaFiltrable } from "../../shared";
import { estiloAccordion } from "./estilos";

/** Procesos que todavía no tienen planificación ingresada. */
export default function CertificadosSinPlanificacion() {
  const [procesos, setProcesos] = useState([]);
  const [cargando, setCargando] = useState(true);

  const toast = useRef(null);
  const navigate = useNavigate();

  useEffect(() => {
    document.title = "Certificados sin planificación";
    accessAPI(
      "GET",
      "admin/proceso/sinplanificacion",
      null,
      (respuesta) => {
        setProcesos(respuesta.procesos || []);
        setCargando(false);
      },
      (respuesta) => {
        toast.current?.show({
          severity: "error",
          summary: "Error",
          detail:
            respuesta[0]?.msg || "Error al cargar procesos sin planificación",
          sticky: true,
        });
        setCargando(false);
      },
    );
    return () => (document.title = tituloBase());
  }, []);

  // Los procesos de juguetes se separan en su propia tabla colapsada
  const juguetes = procesos.filter((p) => p.esjuguetes);
  const resto = procesos.filter((p) => !p.esjuguetes);

  const tabla = (filas, emptyMessage, nombreArchivo) => (
    <TablaFiltrable conFiltros={false}
      value={filas}
      size="small"
      emptyMessage={emptyMessage}
      rowHover
      paginator
      rows={10}
      onRowClick={(e) => {
        const url = `/proceso/${e.data.id}/actividades`;
        e.originalEvent.metaKey || e.originalEvent.ctrlKey
          ? window.open(url, "_blank")
          : navigate(url);
      }}
      css={{ "& .p-datatable-tbody > tr": { cursor: "pointer" } }}
      nombreArchivo={nombreArchivo}
    >
      <Column
        header="Cliente"
        body={(r) => r.cliente?.razonsocial || r.cliente?.nombrefantasia || "—"}
      />
      <Column
        header="Proceso"
        body={(r) =>
          r.nombre ? `${r.nombre} - ${r.nombrefantasia}` : r.nombrefantasia
        }
      />
    </TablaFiltrable>
  );

  return (
    <>
      <Toast ref={toast} position="top-center" />
      <Titulo>Certificados sin planificación</Titulo>

      {cargando ? (
        <Skeleton width="100%" height="10rem" borderRadius="6px" />
      ) : (
        <>
          <Card>
            {tabla(
              resto,
              "No hay procesos sin planificación",
              "procesos_sin_planificacion",
            )}
          </Card>
          {juguetes.length > 0 && (
            <Accordion
              transitionOptions={{ timeout: 0 }}
              css={{ marginTop: "1em", ...estiloAccordion }}
            >
              <AccordionTab header={`Juguetes (${juguetes.length})`}>
                {tabla(
                  juguetes,
                  "No hay procesos de juguetes sin planificación",
                  "procesos_juguetes_sin_planificacion",
                )}
              </AccordionTab>
            </Accordion>
          )}
        </>
      )}
    </>
  );
}
